import { Component, OnInit } from "@angular/core";
import { MapService } from "src/app/features/shared/services/Map.service";

@Component({
  selector: "basemap-selector",
  templateUrl: "./basemap-selector.component.html",
  styleUrls: ["./basemap-selector.component.css"],
})
export class BasemapSelectorComponent implements OnInit {
  bntStyle: string = "cardbasemapSelector2";
  constructor(private _mapService: MapService) {}
  bit: number = 1;
  ngOnInit(): void {}
  onChangeBaseMapSatellite() {
    if(this.bit == 1)
    {
    this._mapService.SetBaseMapSatellite();
    this.bntStyle = "cardbasemapSelector";
    this.bit = 2;
    }else{
      this._mapService.SetBaseMapSatellite();
    this.bntStyle = "cardbasemapSelector2";
    this.bit = 1;
    }
  }
}
